export default "__VITE_ASSET__BIevf3Oo__"